import { useSelector } from 'react-redux';
import { getSplitFeatures } from 'packages/store/user/user.selectors';
import { ActiveSplits } from 'packages/store/user/types';

export const useIsFontManagementEnabled = () =>
    useSelector(getSplitFeatures)?.[ActiveSplits.studioSelfFontManagement] === 'on';
